import { yupResolver } from "@hookform/resolvers/yup";
import { Control, FieldValues, SubmitHandler, UseFormSetError, useForm } from "react-hook-form";
import Modal from 'react-modal';

import { AddMacroModalProps } from "./types";

import { macroValidator } from "./validation";

import { Input } from "components/Form/Input";
import { useCreateMacro } from 'hooks/mutations/useCreateMacro';
import { useEffect, useState } from 'react';
import { Button } from "styles/Button";
import { Form } from "styles/Form";
import { InputGroup } from "styles/InputGroup";
import { MacroTextarea } from 'styles/MacroTextarea';
import { ModalTitle } from "styles/Modal";
import { CreateMacroData } from 'types/Macro';
import closeImg from '../../assets/close.svg';
import { Dropdown } from "components/Dropdown";
import { CategoryList } from "components/EditUserModal/components/CategoryList";
import { Category } from "types/Category";

const validationSchema = macroValidator();

export function AddMacroModal({ isOpen, onRequestClose, macroToAdd }: AddMacroModalProps) {
  const { handleSubmit, setValue, setError, control, reset, formState: { isSubmitting } } = useForm<FieldValues>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      title: '',
      message: '',
      category_id: '',
    },
  });

  useEffect(() => {
    setValue('title', macroToAdd ?? '');
  }, [setValue, macroToAdd]);

  function handleRequestClose() {
    reset();
    onRequestClose();
  }

  const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);

  function handleChangeUserCategory(category: Category) {
    setValue('category_id', category.id);
    setSelectedCategory(category);
  }

  const createMacro = useCreateMacro(setError as UseFormSetError<FieldValues>);

  async function handleCreateNewMacro({ title, message, category_id }: CreateMacroData) {
    await createMacro.mutateAsync({ data: { title, message, category_id } });
    handleRequestClose();
    setSelectedCategory(null);
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content big"
    >
      <button
        type="button"
        onClick={handleRequestClose}
        className="react-modal-close"
      >
        <img src={closeImg} alt="Fechar modal" loading="lazy" />
      </button>

      <div>
        <ModalTitle>Criar macro</ModalTitle>

        <Form onSubmit={handleSubmit(handleCreateNewMacro as SubmitHandler<FieldValues>)}>
          <InputGroup>
            <Input
              control={control as Control<FieldValues>}
              type="text"
              name="title"
              id="title"
              label="Título"
              placeholder="Título do macro"
              maxLength={255}
              fullwidth
            />
          </InputGroup>
          <InputGroup>
            <MacroTextarea
              control={control as Control<FieldValues>}
              name="message"
              id="macroMessage"
              label="Mensagem"
              placeholder="Mensagem do macro"
              rows={4}
              fullwidth
            />
          </InputGroup>
          <InputGroup style={{ paddingBottom: '70px' }}>
            <Dropdown
              trigger={
                <Button
                  type="button"
                  medium={!window.matchMedia("(max-width: 1366px)").matches}
                  small={window.matchMedia("(max-width: 1366px)").matches}
                  dropdown
                >
                  {selectedCategory ? selectedCategory.name : 'Setor'}
                </Button>
              }
              closeOnClickInside={true}
            >
              <CategoryList
                handleChangeUserCategory={handleChangeUserCategory}
              />
            </Dropdown>
          </InputGroup>
          <InputGroup>
            <Button type="submit" fullwidth disabled={isSubmitting}>
              {isSubmitting ? 'Carregando...' : 'Criar macro'}
            </Button>
          </InputGroup>
        </Form>
      </div>
    </Modal>
  );
}
